import { useState } from 'react';
import { observer } from 'mobx-react';

import AppStore from 'AppStore';

import './CookieConsent.scss';

const COOKIE_CONSENT_KEY = 'cookie_consent';

export const CookieConsent = observer(() => {
    const [isVisible, setIsVisible] = useState(
        () => !sessionStorage.getItem(COOKIE_CONSENT_KEY)
    );

    if (AppStore.isAuth || !isVisible) {
        return null;
    }

    const handleAccept = () => {
        sessionStorage.setItem(COOKIE_CONSENT_KEY, 'true');
        setIsVisible(false);
    };

    return (
        <div className="cookie-consent">
            <div className="cookie-consent__text">
                Мы обрабатываем файлы cookie, чтобы улучшить работу сайта.
                Оставаясь на нашем сайте, вы соглашаетесь с&nbsp;
                <a
                    href="/docs/policy.pdf"
                    target="_blank"
                    rel="noreferrer"
                >
                    Политикой пользовательских данных
                </a>
                . Если вы хотите запретить обработку файлов cookie,
                отключите cookie в настройках вашего браузера.
            </div>

            <button
                className="cookie-consent__button"
                type="button"
                onClick={handleAccept}
            >
                Согласиться
            </button>
        </div>
    );
});